// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataCollapseTable_wrapper__1NJim","nameCell":"DataCollapseTable_nameCell__1oe2Y"};